import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import { useConsumerMyPageHeader } from 'bundles/composable-page-header-consumer/contexts/ConsumerMyPageHeaderContext';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import NotificationsLegacyGridItem from 'bundles/composable-page-header/components/grid-items/NotificationsLegacyGridItem';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import MobileMenuIconGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuIconGridItem';
import MobileSearchBarGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileSearchBarGridItem';
import LoggedInMobileMenuConfigWithMetaNav from 'bundles/composable-page-header/module-renderers/LoggedInMobileMenuConfigWithMetaNav';

type Props = {
  showDiscoveryElements?: boolean;
  showSearch?: boolean;
};

const LoggedInConsumerWithMetaNavLinksMobileMainNav = ({ showDiscoveryElements = true, showSearch = true }: Props) => {
  const {
    enrolledDegreePrograms,
    enrolledEnterprisePrograms,
    isCourseraPlusLearner,
    chosenDegree,
    chosenEnterpriseProgram,
    hasEnrolledPrograms,
    naptimeManagedThirdPartyOrganizations,
    hasCheatingIncidents,
    canViewEducatorAdminLink,
    courseraPlusSubscriptionCycle,
  } = useConsumerMyPageHeader();

  return (
    <MainNavigationWrapper>
      <Grid item xs={8} sm={6} container alignItems="center">
        <MobileMenuIconGridItem
          menuConfig={
            <LoggedInMobileMenuConfigWithMetaNav
              showDiscoveryElements={showDiscoveryElements}
              enrolledDegreePrograms={enrolledDegreePrograms}
              enrolledEnterprisePrograms={enrolledEnterprisePrograms}
              isCourseraPlusLearner={isCourseraPlusLearner}
              chosenDegree={chosenDegree}
              chosenEnterpriseProgram={chosenEnterpriseProgram}
              hasEnrolledPrograms={!!hasEnrolledPrograms}
              naptimeManagedThirdPartyOrganizations={naptimeManagedThirdPartyOrganizations}
              hasCheatingIncidents={hasCheatingIncidents}
              canViewEducatorAdminLink={canViewEducatorAdminLink}
              courseraPlusSubscriptionCycle={courseraPlusSubscriptionCycle}
            />
          }
          homeLogo={<HomeLogoGridItemModule href="/" logos={[<CourseraHomeLogo key="1" />]} />}
        />
        <HomeLogoGridItemModule href="/" logos={[<CourseraHomeLogo key="1" />]} />
      </Grid>
      <Grid item container xs={4} sm={6} alignItems="center" justifyContent="flex-end">
        <NotificationsLegacyGridItem />
        {showSearch && showDiscoveryElements && <MobileSearchBarGridItem />}
      </Grid>
    </MainNavigationWrapper>
  );
};

export default LoggedInConsumerWithMetaNavLinksMobileMainNav;
